const dataMessage = (role, content) => ({
  role: role,
  content: content
});

export default dataMessage;
